import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processCancellationData = (
  cardData: {
    title: string;
    description: string;
    isValid?: boolean;
  },
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const validationData = processValidation(validation);

  return {
    title: cardData.title,
    description: cardData.description,
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      isValid: validationData.isValid,
      remarks: remarks.length ? remarks[0].text : null,
    },
  };
};
